import { createAsyncThunk } from '@reduxjs/toolkit';
import { StoreState } from '../../../store/store.interface';
import { getUserSchools } from '../api/get-schools';
import { selectSegment } from '../user-profile.selectors';

interface FetchSchoolRequest {
  countryCode: string;
  stateCode: string;
  zipCode: string;
  searchText: string;
  segment?: string;
  start?: number;
}

export const fetchSchools = createAsyncThunk(
  'userProfile/fetchSchools',
  async ({ countryCode, stateCode, zipCode, searchText, segment, start }: FetchSchoolRequest, thunkAPI) => {
    try {
      const state = thunkAPI.getState() as StoreState;
      const filter = {
        segment: segment ?? selectSegment(state),
      };

      if (countryCode) filter['country'] = countryCode;
      if (stateCode) filter['state'] = stateCode;
      if (zipCode) filter['postalcode'] = zipCode;

      const request = {
        size: 50,
        filter,
        start: start ?? 0,
        sortBy: "name",
        sortOrder: "ASC"
      };
      if (searchText) {
        request['search'] = { name: { term: searchText } };
      }

      return await getUserSchools(request);
    } catch (error) {
      console.error(error);
      return thunkAPI.rejectWithValue(error);
    }
  }
);
